<template>
  <div>
    <tci-about-us :title="$t('history.pageTitle')">
      <v-row no-gutters>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col>
          <v-list :width='isMobile?"":600'>
            <div v-for="item in $t('history.infos')" :key="item.text">
              <v-divider></v-divider>
              <v-list-item>
                <v-row align = "center">
                  <v-col cols="4" sm="3">
                    <v-list-item-title>{{ item.time }}</v-list-item-title>
                  </v-col>
                  <v-col cols="8" sm="9">
                    <v-list-item-content class="body-1">{{ item.text }}</v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
            </div>
          </v-list>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-divider></v-divider>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
    name: 'CompanyPass',
    data: () => ({
      isMobile: false
    }),
    components: {
      "tci-about-us": TciAboutUs,
      "tci-contact-footer": TciContactFooter
    },
    mounted() {
      this.isMobile = this.$vuetify.breakpoint.xs;
    }
}
</script>
